<div class="sl-body template-social">
  <div class="container">
    <div class="template_sl">

      <!-- Dynamic template name badge -->
      <div class="sl-type-badge">{{ templateName }}</div>

      <!-- Profile -->
      <header class="sl-head">
        <div class="sl-avatar"><img [src]="imageSrc" alt="profileImage" /></div>
        <h1>{{ firstName + ' ' + lastName }}</h1>
        <p class="sl-job">{{ jobTitle }}<span *ngIf="companyName"> · {{ companyName }}</span></p>
        <div class="sl-about" *ngIf="content" [innerHTML]="content"></div>
      </header>

      <!-- Quick contact -->
      <section class="sl-contact">
        <a [href]="'tel:' + phone" class="sl-c-tel"><i class="fa-solid fa-phone"></i></a>
        <a [href]="'sms:' + phone" *ngIf="phoneAllow" class="sl-c-sms"><i class="fa-solid fa-comments"></i></a>
        <a [href]="'mailto:' + email" class="sl-c-mail"><i class="fa-solid fa-envelope"></i></a>
        <a [href]="'https://www.google.com/maps?q=' + address" target="_blank" class="sl-c-map" *ngIf="address"><i class="fa-solid fa-location-dot"></i></a>
      </section>

      <!-- Social buttons -->
      <section class="sl-socials" *ngIf="instagram || youtube || pinterest || linkedin || facebook || twitter">
        <a class="sl-sbtn sl-b-instagram" *ngIf="instagram" [href]="instagram" target="_blank">
          <i class="sl-ic fa-brands fa-instagram"></i>
          <span class="sl-txt"><b>Instagram</b><small>Follow me</small></span>
          <i class="sl-go fa-solid fa-arrow-right"></i>
        </a>
        <a class="sl-sbtn sl-b-youtube" *ngIf="youtube" [href]="youtube" target="_blank">
          <i class="sl-ic fa-brands fa-youtube"></i>
          <span class="sl-txt"><b>YouTube</b><small>Subscribe</small></span>
          <i class="sl-go fa-solid fa-arrow-right"></i>
        </a>
        <a class="sl-sbtn sl-b-pinterest" *ngIf="pinterest" [href]="pinterest" target="_blank">
          <i class="sl-ic fa-brands fa-pinterest-p"></i>
          <span class="sl-txt"><b>Pinterest</b><small>Pin with me</small></span>
          <i class="sl-go fa-solid fa-arrow-right"></i>
        </a>
        <a class="sl-sbtn sl-b-linkedin" *ngIf="linkedin" [href]="linkedin" target="_blank">
          <i class="sl-ic fa-brands fa-linkedin-in"></i>
          <span class="sl-txt"><b>LinkedIn</b><small>Connect</small></span>
          <i class="sl-go fa-solid fa-arrow-right"></i>
        </a>
        <a class="sl-sbtn sl-b-facebook" *ngIf="facebook" [href]="facebook" target="_blank">
          <i class="sl-ic fa-brands fa-facebook-f"></i>
          <span class="sl-txt"><b>Facebook</b><small>Like my page</small></span>
          <i class="sl-go fa-solid fa-arrow-right"></i>
        </a>
        <a class="sl-sbtn sl-b-twitter" *ngIf="twitter" [href]="twitter" target="_blank">
          <i class="sl-ic fa-brands fa-twitter"></i>
          <span class="sl-txt"><b>Twitter</b><small>Follow me</small></span>
          <i class="sl-go fa-solid fa-arrow-right"></i>
        </a>
      </section>

      <!-- Custom link buttons -->
      <section class="sl-links" *ngIf="buttons && buttons.length > 0 && buttons[0].LinkButtonTitle">
        <ng-container *ngFor="let button of buttons">
          <a class="sl-link" *ngIf="button" [href]="button.LinkButtonLink" target="_blank">
            <i class="sl-dot" [style.background-color]="buttonColor || null"></i>
            <span>{{ button.LinkButtonTitle }}</span>
            <i class="sl-go fa-solid fa-arrow-up-right-from-square"></i>
          </a>
        </ng-container>
      </section>

      <div class="sl-facts" *ngIf="gpa || school || grade || height || age || weight">
        <span *ngIf="gpa"><b>GPA</b> {{ gpa }}</span>
        <span *ngIf="school"><b>School</b> {{ school }}</span>
        <span *ngIf="grade"><b>Grade</b> {{ grade }}</span>
        <span *ngIf="height"><b>Height</b> {{ height }}</span>
        <span *ngIf="age"><b>Age</b> {{ age }}</span>
        <span *ngIf="weight"><b>Weight</b> {{ weight }}</span>
      </div>

      <section class="sl-gallery" *ngIf="productImages">
        <img *ngFor="let img of productImages; trackBy: trackByIndex" [src]="img" alt="productImage" />
      </section>

      <!-- VIDEOS: YouTube + Umyotube (YouTube / Dailymotion / umyovideo) + Vimeo -->
      <section class="sl-videos">
        <div class="sl-sec-title" *ngIf="(youtubeArray && youtubeArray.length > 0 && youtubeArray[0].youtubeLink) || (vimeoArray && vimeoArray.length > 0 && vimeoArray[0].vimeoVideoLink) || (umyotubeArray && umyotubeArray.length > 0 && umyotubeArray[0].umyotubeLink)">
          <i class="fa-solid fa-circle-play"></i> Watch
        </div>

        <ng-container *ngFor="let v of youtubeArray">
          <div class="sl-video" *ngIf="v.youtubeLink | videoEmbed as src">
            <p class="sl-video-title"><i class="fa-brands fa-youtube"></i> {{ v.youtubeTitle }}</p>
            <div class="sl-embed">
              <iframe [src]="src" [title]="v.youtubeTitle || 'YouTube player'" frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
          </div>
        </ng-container>

        <ng-container *ngFor="let v of umyotubeArray">
          <div class="sl-video" *ngIf="v.umyotubeLink | videoEmbed as src">
            <p class="sl-video-title"><i class="fa-solid fa-circle-play"></i> {{ v.umyotubeTitle }}</p>
            <div class="sl-embed">
              <iframe [src]="src" title="Umyotube player" frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>
        </ng-container>

        <ng-container *ngFor="let v of vimeoArray">
          <div class="sl-video" *ngIf="v.vimeoVideoLink | videoEmbed as src">
            <p class="sl-video-title"><i class="fa-brands fa-vimeo-v"></i> {{ v.vimeoVideoTitle }}</p>
            <div class="sl-embed">
              <iframe [src]="src" [title]="v.vimeoVideoTitle || 'Vimeo player'" frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>
        </ng-container>
      </section>

      <div class="sl-ctrls">
        <button type="button" class="ctrl-item" *ngIf="forwardCard" data-bs-toggle="modal" data-bs-target="#shareCard">
          <i class="fa-solid fa-share"></i><h3>Forward</h3>
        </button>
        <a (click)="navigateToHome()" type="button" class="ctrl-item">
          <i class="fa-solid fa-right-to-bracket"></i><h3>Sign Up</h3>
        </a>
        <button type="button" class="ctrl-item" *ngIf="saveCard" (click)="downloadVCard()">
          <i class="fa-solid fa-download"></i><h3>Save My Card</h3>
        </button>
      </div>

      <footer class="sl-footer">
        <img class="sl-qr" *ngIf="qrCodeImage" [src]="qrCodeImage" alt="QR Code" />
        <p class="sl-strip">Follow <i></i> Share <i></i> Connect</p>
        <p class="sl-powered">This card is powered by <span>UMYO Cards</span></p>
        <form action="" class="referal-form" *ngIf="inviteCode">
          <label for="referal">Referral ID: </label>
          <input type="text" name="referal" id="referal" [value]="referal" disabled placeholder="XXXXX" />
        </form>
        <a [routerLink]="['/']" class="call-to-action">
          <span class="left">Click<br />Here</span>
          <span class="right">Design your card now!</span>
        </a>
      </footer>

    </div>
  </div>
</div>